@if (checkingUser) {
  <div class="blanket">
    <div style="font-size: 30px; margin: auto; border: 3px solid red; cursor:wait;
       border-radius: 10px; width: max-content; padding: 10px;" >
      <p style="text-align: left;">Please Wait<p>
      <p style="text-align: center;">Login you to the system<p>
    </div>
  <!--    <div style="text-align: center; width: 100%;">-->
  <!--      <img class='spinner' src="../assets/target-icons/loader.gif" alt=''>-->
  <!--    </div>-->
  </div>
}
@else {
  <app-core-layout></app-core-layout>
}
